module.exports = __webpack_public_path__ + "img/202105.13977c16.png";